import React from "react";
import { Redirect, Route } from "react-router-dom";
import { withRedux } from "helpers";

const ProtectedRoute = ({
  component: Component,
  path,
  platformInfo,
  ...props
}) => {
  let {
    status: { user },
  } = platformInfo;

  // if (window.drift && window.drift.api) {
  //   window.drift.api.widget.hide();
  // }

  return (
    <Route
      path={path}
      render={(props) =>
        user ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default withRedux(ProtectedRoute);
